<script>
import Utils from '../../common/Utils';
import CommonConstants from '../../common/Constants';
import Service from '@/services/movement-instruction';
import { FilterMatchMode, FilterOperator } from 'primevue/api'
import GenericCustomMasterDataAutocompleteV2 from '@/components/generic/GenericCustomMasterDataAutocompleteV2.vue';

export default {
    components: 
        {
            //GenericCustomMasterDataAutocompleteV2
        },
    props: [],
    data() {
        return {                          
            filterCombo: {},
            updateMode: false,
            productQuantity: {},
            transferStock: {},
            periodStartDate : Utils.setFirstDayOfMonth(Utils.formatDatePlusMonths(new Date(), -1)),
            periodEndDate : Utils.setLastDayOfMonth(Utils.formatDatePlusMonths(new Date(), 0)),
            periodEndDateTs : Utils.setLastDayOfMonth(Utils.formatDatePlusMonths(new Date(), 0)),
            selectedItems: []
        }
    },
    created() {
        this.$store.dispatch('security/setNavbarTitle', this.$t("weeklySettlement.page_title"));
    },
    mounted() {
        let cacheFilters = null;
        let cacheData = this.$store.getters['cacheDataStore/getGridCache']('ProductQuantity');
        if(cacheData){
            cacheFilters = {};
            for(let i = 0; i < cacheData.length; i++){
                let element = cacheData[i];
                cacheFilters[element.property] = element;
                this.filters[element.propName] = element.value;
            }
            if(cacheFilters){
                this.loadProductQuantity();
            }
        }
    },
    computed: {
        constants() {
            return CommonConstants; 
        },
        utils() {
            return Utils;
        },
        uiPermissions() {
            return this.$store.getters['security/uiPermissions'];
        }
    },
    methods: {
        loadProductQuantity(){          
            let body = {
                periodStartDate: this.periodStartDate,
                periodEndDate: this.periodEndDate
            }
         
            //this.$store.dispatch("cacheDataStore/setGridCache", cacheData);
            this.$store.dispatch("generic/setLoading", true);
            Service.checkTransferStock(body, response => {
                if(response.success){
                    Service.getProductQuantity(body, res => {
                        this.$store.dispatch("generic/setLoading", false);
                        if(res.success){
                            this.productQuantity = res.data;                 
                        }else{
                            this.$toast.add({detail: res.message && res.message != '' ? res.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    })               
                }else{
                    this.$store.dispatch("generic/setLoading", false);
                    this.$confirm.require({
                        message: this.$t('weeklySettlement.exitMessage'),
                        icon: 'pi pi-exclamation-triangle',
                        acceptLabel: this.$t('exit'),  
                        rejectLabel: this.$t(''),    
                        rejectClass: 'hidden p-button-outlined p-button-sm',    
                        accept: () => {
                            this.$confirm.close();
                        }
                    });
                }
            })
        },
        loadTransferStock(){          
            let body = {
                periodEndDate: this.periodEndDateTs
            }

            //this.$store.dispatch("cacheDataStore/setGridCache", cacheData);
            this.$store.dispatch("generic/setLoading", true);
            Service.getTransferStock(body, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.transferStock = response.data;                 
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        importProductQuantity(){   
            console.log(this.selectedItems);

            let body = {
                transferStocksList: this.selectedItems,
                periodEndDate: this.periodEndDate
            }
           
            //this.$store.dispatch("cacheDataStore/setGridCache", cacheData);
            this.$confirm.require({
                message: this.$t('messages.confirm_import'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),  
                rejectLabel: this.$t('no'),       
                accept: () => {
                    this.$store.dispatch("generic/setLoading", true);
                    Service.importSelectedTransferStock(body, response => {
                        this.$store.dispatch("generic/setLoading", false);
                        if(response.success){
                            this.productQuantity = response.data;
                            this.$toast.add({detail: this.$t('messages.upload_message_success'), life:5000, severity:'success'});                 
                        }else{
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:5000, severity:'error'});
                        }
                    })
                },
                reject: () => {
                    this.$confirm.close();
                }
            });
        }
    }
}
</script>

<template>
    <main>
        <div class="col-12 data">
            <TabView>
                <TabPanel :header="$t('weeklySettlement.productQuantity')">
                    <div class="grid"> 
                        <div class="col-12 lg:col-2 md:col-6">
                            <label for="periodStartDate">{{ $t('weeklySettlement.periodStartDate') }}</label>
                            <Calendar
                                class="p-inputtext-sm w-full"
                                placeholder="__/__/____"
                                v-model="this.periodStartDate"
                                name="periodStartDate" dateFormat="dd/mm/yy" :showTime="false"
                                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                        </div>
                        <div class="col-12 lg:col-2 md:col-6">
                            <label for="periodEndDate">{{ $t('weeklySettlement.periodEndDate') }}</label>
                            <Calendar
                                class="p-inputtext-sm w-full"
                                placeholder="__/__/____"
                                v-model="this.periodEndDate"
                                name="periodEndDate" dateFormat="dd/mm/yy" :showTime="false"
                                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                        </div>   
                        <div class="col-12 lg:col-4 mt-2">
                            <Button type="button" icon="pi pi-replay" class="p-button-sm mx-2 my-3" :label="$t('weeklySettlement.load')" severity="secondary" @click="loadProductQuantity" />
                            <Button type="button" icon="pi pi-check" class="p-button-sm p-button-outlined mx-2 my-3" :label="$t('weeklySettlement.import')" severity="info" v-if="this.productQuantity.length > 0" @click="importProductQuantity" />
                        </div>             
                    </div>   
                    
                    <DataTable showGridlines :value="productQuantity" scrollable :responsiveLayout="'scroll'" breakpoint="960px" sortMode="single" 
                    :sortOrder="1" size="small" v-model:selection="selectedItems">
                        <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
                        <Column field="code" :header="$t('weeklySettlement.code')"></Column>
                        <Column field="productName" :header="$t('weeklySettlement.productName')"></Column>
                        <Column field="quantity" :header="$t('weeklySettlement.quantity')"></Column>
                        <Column field="isImportable" :header="$t('weeklySettlement.isImportable')">
                            <template #body="{ data, field }">
                                <i class="pi" :class="{ 'pi-check-circle text-green-500': data[field], 'pi-times-circle text-red-500': !data[field] }"></i>
                            </template>
                        </Column>
                        <Column field="errorString" :header="$t('weeklySettlement.errorString')"></Column>
                    </DataTable>
                </TabPanel>

                <TabPanel header="TransferStock">
                    <div class="grid"> 
                        <div class="col-12 lg:col-2 md:col-6">
                            <label for="periodEndDate">{{ $t('weeklySettlement.periodEndDate') }}</label>
                            <Calendar
                                class="p-inputtext-sm w-full"
                                placeholder="__/__/____"
                                v-model="this.periodEndDateTs"
                                name="periodEndDate" dateFormat="dd/mm/yy" :showTime="false"
                                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                        </div> 
                        <div class="col-12 lg:col-4 mt-2">
                            <Button type="button" icon="pi pi-replay" class="p-button-sm mx-2 my-3" :label="$t('weeklySettlement.loadTransferStock')" severity="secondary" @click="loadTransferStock" />
                        </div>
                    </div>    
                    
                    <DataTable showGridlines :value="transferStock" scrollable :responsiveLayout="'scroll'" breakpoint="960px" sortMode="single" :sortOrder="1" size="small">
                        <Column field="code" :header="$t('weeklySettlement.code')"></Column>
                        <Column field="productName" :header="$t('weeklySettlement.productName')"></Column>
                        <Column field="quantity" :header="$t('weeklySettlement.quantity')"></Column>
                        <Column field="operationType" :header="$t('weeklySettlement.operationType')"></Column>
                        <Column field="voyageNumber" :header="$t('weeklySettlement.voyageNumber')"></Column>
                        <Column field="isCreated" :header="$t('weeklySettlement.isCreated')">
                            <template #body="{ data, field }">
                                <i class="pi" :class="{ 'pi-check-circle text-green-500': data[field], 'pi-times-circle text-red-500': !data[field] }" style="font-size: 10px;"></i>
                            </template>
                        </Column>
                        <Column field="lotManagementCheck" :header="$t('weeklySettlement.lotManagementCheck')">
                            <template #body="{ data, field }">
                                <i class="pi" :class="{ 'pi-check-circle text-green-500': data[field], 'fas fa-exclamation-triangle': !data[field] }" style="font-size: 10px;"></i>
                            </template>
                        </Column>
                    </DataTable>
                </TabPanel>
            </TabView>
        </div>
    </main>
</template>

